"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const src_1 = __importDefault(require("./src"));
vue_1.default.use(src_1.default, {
    single: false,
    principleLoader: function () {
        const http = vue_1.default.prototype.$http;
        const all = [/* http.get('/auth/info') */ Promise.resolve({ username: 'zhangsan', name: '张三' })];
        return Promise.all(all).then(([user]) => {
            return {
                user: Object.assign({ username: user.username, cname: user.name }, user),
                roles: [],
                authorities: []
            };
        });
    },
    logoutHandler: function () {
        const http = vue_1.default.prototype.$http;
        return http.post('/logout');
    },
    loginHandler: function (params) {
        const http = vue_1.default.prototype.$http;
        return http.post('/login', {}, { params });
    }
});
